// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"FE-z","sponsoredTooltipWrapper":"GE-z","sponsoredTooltip":"HE-z","newCard":"IE-z"};